import ErrorReporter from 'scripts/infrastructure/error_reporter';

export default class OutgoingSmsGatewayObserver {
  constructor(context) {
    this.context = context;
  }

  onAddError(error, params) {
    ErrorReporter.reportError(new Error(`OutgoingSmsGatewayObserver sms send error`), {
      extra: {
        code: error && error.code,
        status: error && error.status,
        itemId: params && params.id,
      },
    });
  }
}
